import { digital_list } from "./DigitalListData";
import { traditional_list } from "./TraditionalListData";
// import ImageGallery from "react-image-gallery";
// import PhotoAlbum from "react-photo-album";
// import { images, imagesGal } from "../images";
// import { design_list } from "./DesignListData";

export const all_data = [
  ...digital_list,
  // ...design_list,
  ...traditional_list,
];
